import {
  SET_LOADING,
  REMOVE_LOADING,
  SET_USER_DATA,
  CLEAR_STORAGE,
  SET_REGIONS,
  SET_ROLES,
  SET_OFFICES,
  SET_VENDOR,
  SET_BRAND,
  SET_USERS,
  SET_REASON,
  SET_DOCUMENTS,
  SET_EFDSTATUS,
  SET_DEVICE_STATUS,
  SET_PAYMENT_METHODS,
  SET_PAYMENT_STATUS,
  SET_TAX_GROUP,
  SET_PACKAGE_TYPE,
} from "../Types/shared";

const initialState = {
  loading: false,
  userData: "",
  packageType: [
    {
      id: 1,
      discription: "",
      extendedIndo: null,
    },
  ],
  taxGroup: [
    {
      id: 1,
      discription: "",
      extendedIndo: null,
    },
  ],
  regions: [
    {
      id: 0,
      discription: "",
    },
  ],
  roles: [
    {
      id: 0,
      discription: "",
    },
  ],
  documents: [
    {
      id: 0,
      discription: "",
    },
  ],
  paymentMethods: [
    {
      id: 0,
      discription: "",
    },
  ],
  operationStatus: [
    {
      id: 0,
      discription: "",
    },
  ],
  deviceStatus: [
    {
      id: 0,
      discription: "",
    },
  ],
  paymentStatus: [
    {
      id: 0,
      discription: "",
    },
  ],
  offices: [
    {
      officeID: 0,
      officeName: "",
    },
  ],
  vendors: [
    {
      vendorID: 0,
      vendorName: "",
    },
  ],
  brands: [
    {
      id: 0,
      discription: "",
    },
  ],
  reasons: [
    {
      id: 0,
      discription: "",
    },
  ],
  users: [
    {
      staffID: 0,
      roleID: 0,
      firstName: "string",
      lastName: "string",
      userName: "string",
      phone: "string",
      email: "string",
      officeID: 0,
      password: "string",
      active: 0,
    },
  ],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

      break;
    case REMOVE_LOADING:
      return {
        ...state,
        loading: false,
      };

      break;
    case SET_TAX_GROUP:
      return {
        ...state,
        taxGroup: action.payload,
      };

      break;
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };

      break;

    case SET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };

      break;
    case SET_OFFICES:
      return {
        ...state,
        offices: action.payload,
      };

      break;
    case SET_REASON:
      return {
        ...state,
        reasons: action.payload,
      };

      break;
    case SET_USERS:
      return {
        ...state,
        users: action.payload,
      };

      break;
    case SET_EFDSTATUS:
      return {
        ...state,
        operationStatus: action.payload,
      };

      break;
    case SET_VENDOR:
      return {
        ...state,
        vendors: action.payload,
      };

      break;
    case SET_ROLES:
      return {
        ...state,
        roles: action.payload,
      };

      break;

    case SET_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };
      break;
    case SET_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
      };
      break;
    case SET_DEVICE_STATUS:
      return {
        ...state,
        deviceStatus: action.payload,
      };

      break;
    case SET_PACKAGE_TYPE:
      return {
        ...state,
        packageType: action.payload,
      };

      break;
    case SET_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: action.payload,
      };

      break;
    case SET_BRAND:
      return {
        ...state,
        brands: action.payload,
      };

      break;
    case SET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };

      break;
    case CLEAR_STORAGE:
      return {
        ...state,
        userData: "",
        loading: false,
        regions: [
          {
            id: 0,
            discription: "",
          },
        ],
        roles: [
          {
            id: 0,
            discription: "",
          },
        ],
        vendors: [
          {
            vendorID: 0,
            vendorName: "",
          },
        ],
        brands: [
          {
            id: 0,
            discription: "",
          },
        ],
        operationStatus: [
          {
            id: 0,
            discription: "",
          },
        ],
        deviceStatus: [
          {
            id: 0,
            discription: "",
          },
        ],
        paymentMethods: [
          {
            id: 0,
            discription: "",
          },
        ],
        users: [
          {
            staffID: 0,
            roleID: 0,
            firstName: "string",
            lastName: "string",
            userName: "string",
            phone: "string",
            email: "string",
            officeID: 0,
            password: "string",
            active: 0,
          },
        ],
        paymentStatus: [
          {
            id: 0,
            discription: "",
          },
        ],
        reasons: [
          {
            id: 0,
            discription: "",
          },
        ],
      };

      break;
    default:
      return state;
      break;
  }
};
